import React, { FC, useEffect } from 'react';
import Flow, { FlowStepCallback } from 'components/Common/Flow/Flow';
import { Store } from 'store';
import { useDispatch, useSelector } from 'react-redux';
import { AddToCartFlow } from 'store/product/types';
import { AvailableFlows, AvailablePopups } from 'store/app/types';
import showPopupOperation from 'store/app/operation/showPopupOperation';
import { nextStepFlowAction } from 'store/app/slice';
import useIsServer from 'hooks/useIsServer';
import { AppBundle } from 'api/optimalprint-sdk.d';
// import ContinueShopingPopup from '../ContinueShopingPopup/ContinueShopingPopup';
import getSelectedBundleProducts from 'store/publicAssetProduct/selector/getSelectedBundleProducts';
import FrameUpsellPopup from '../StudioFrameUpsellPopup/StudioFrameUpsellPopup';

export interface StudioPostAddToCartFlowProps {
  currentAddToCartFlow: AddToCartFlow | undefined;
  goToBasketCallback: () => void;
  frameUpsellData: AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response | undefined;
  frameProductId: number | undefined;
  popupTitle: string;
  addToBasketCallback: () => void;
  selectedFrame: AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response.IUpsellItem | undefined;
  categoryId: number | undefined;
  voucher: string;
  previewUrl: string;
  frames: AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response.IUpsellItem[];
  activeFrameProductId: number | undefined;
  frameTitle: string | undefined;
  frameDescription: string | null | undefined;
  selectFrameCallback: (
    frame: AppBundle.Api.Response.ProductUpsell.V1.ProductUpsellScreenV1Response.IUpsellItem,
    frameIndex: number,
  ) => void;
  fetchFrameUpsellData: () => void;
}

const StudioPostAddToCartFlow: FC<StudioPostAddToCartFlowProps> = ({
  currentAddToCartFlow,
  goToBasketCallback,
  frameUpsellData,
  activeFrameProductId,
  addToBasketCallback,
  categoryId,
  frameDescription,
  frameProductId,
  frameTitle,
  frames,
  popupTitle,
  previewUrl,
  selectFrameCallback,
  selectedFrame,
  voucher,
  fetchFrameUpsellData,
}) => {
  const dispatch = useDispatch();
  const isServer = useIsServer();
  if (isServer) {
    return null;
  }
  const selectedBundleProducts = useSelector(getSelectedBundleProducts);

  useEffect(() => {
    if (currentAddToCartFlow === AddToCartFlow.addedToCart) {
      dispatch(nextStepFlowAction(AvailableFlows.postAddToCart));
    }
  }, [currentAddToCartFlow]);

  const goToBasket = () => {
    goToBasketCallback();
  };

  const showFrameUpselllPopup: FlowStepCallback = async (getState: () => Store, nextStep: () => void) => {
    await fetchFrameUpsellData();
    const isFrameUpsellDataAvailable = Boolean(frameUpsellData);
    const isBundledProductSelected = selectedBundleProducts.some((selectedProduct) => selectedProduct.productId > 0);
    if (isFrameUpsellDataAvailable && !isBundledProductSelected) {
      dispatch(showPopupOperation(AvailablePopups.frameUpsellPopup));
      return;
    }
    nextStep();
  };

  return (
    <>
      {/* <ContinueShopingPopup /> */}
      <FrameUpsellPopup
        activeFrameProductId={activeFrameProductId}
        addToBasketCallback={addToBasketCallback}
        categoryId={categoryId}
        frameDescription={frameDescription}
        frameProductId={frameProductId}
        frameTitle={frameTitle}
        frames={frames}
        popupTitle={popupTitle}
        previewUrl={previewUrl}
        selectFrameCallback={selectFrameCallback}
        selectedFrame={selectedFrame}
        voucher={voucher}
      />
      <Flow flowId={AvailableFlows.postAddToCart} flowSteps={[showFrameUpselllPopup, goToBasket]} />
    </>
  );
};

export default StudioPostAddToCartFlow;
